import {trackEvent} from '@lib/infrastructure';
import {useExtraServiceUrl} from '@lib/logic';
import {ExtraService} from '@lib/store';
import {FlexCol, FlexRow, H4, Subtitle} from '@quarks';
import {getExtrasServicesIcons} from '@utils';
import {StyledAnimatedButton} from './styles';
import {Icon} from '@atoms';

type Props = {
  service: ExtraService;
  meetingId: string | undefined;
  selectedDate: string | undefined;
  locationName: string | undefined;
};

export const ExtraServiceSelectionCell = ({service, locationName, meetingId, selectedDate}: Props) => {
  const url = useExtraServiceUrl(service, meetingId, selectedDate, locationName);

  const onClick = () => {
    trackEvent('ExtraServices_OpenService', {
      serviceType: service.serviceType,
      category: service.category,
      buildingId: service.buildingId,
    });
    window.open(url, '_blank');
  };

  return (
    <StyledAnimatedButton
      role="button"
      tabIndex={0}
      onClick={onClick}>
      <FlexRow
        flex="1"
        alignItems="center">
        <FlexRow
          gap={16}
          alignItems="center">
          <Icon
            icon={getExtrasServicesIcons(service.serviceType)}
            size="1.25rem"
          />

          <FlexCol>
            <H4 className="truncate flex-1">{service.title}</H4>
            {service.description?.length ? <Subtitle>{service.description}</Subtitle> : null}
          </FlexCol>
        </FlexRow>

        <Icon
          icon={'openInBrowser'}
          color="#767676"
          size="20px"
        />
      </FlexRow>
    </StyledAnimatedButton>
  );
};
